import {
  accountKeys,
  companyAccountKeys,
  individualMeterKeys,
  ownerKeys,
} from './settingStepFieldKeys';
import { importTypes } from './importTypes';
import { baseFormat, dateTime } from '../../lib/dateTime';

const toDateStr = (value) =>
  value ? dateTime(value).format(baseFormat) : value;

const ownersFields = {
  [ownerKeys.addressType]: {
    name: ownerKeys.addressType,
    label: 'ID типа помещения',
  },

  [ownerKeys.flat]: {
    name: ownerKeys.flat,
    label: 'Номер помещения',
  },

  [ownerKeys.surName]: {
    name: ownerKeys.surName,
    label: 'Фамилия',
  },

  [ownerKeys.firstName]: {
    name: ownerKeys.firstName,
    label: 'Имя',
  },

  [ownerKeys.partName]: {
    name: ownerKeys.partName,
    label: 'Отчество',
  },

  [ownerKeys.phone]: {
    name: ownerKeys.phone,
    label: 'Телефон',
  },

  [ownerKeys.email]: {
    name: ownerKeys.email,
    label: 'Эл. почта',
  },
};

const personalAccountsFields = {
  [accountKeys.addressType]: {
    name: accountKeys.addressType,
    label: 'ID типа помещения',
  },
  [accountKeys.flat]: { name: accountKeys.flat, label: 'Номер помещения' },
  [accountKeys.account]: { name: accountKeys.account, label: 'Лицевой счет' },
  [accountKeys.accountType]: {
    name: accountKeys.accountType,
    label: 'ID типа лицевого счета',
  },
};

const companyPersonalAccountsFields = {
  [companyAccountKeys.account]: {
    name: companyAccountKeys.account,
    label: 'Лицевой счет',
  },
  [companyAccountKeys.address]: {
    name: companyAccountKeys.address,
    label: 'Адрес',
  },
  [companyAccountKeys.balance]: {
    name: companyAccountKeys.balance,
    label: 'Баланс',
  },
};

const individualMetersFields = {
  [individualMeterKeys.addressType]: {
    name: individualMeterKeys.addressType,
    label: 'ID типа помещения',
  },
  [individualMeterKeys.flat]: {
    name: individualMeterKeys.flat,
    label: '№ помещения',
  },
  [individualMeterKeys.serviceType]: {
    name: individualMeterKeys.serviceType,
    label: 'ID Услуги',
  },
  [individualMeterKeys.serialNumber]: {
    name: individualMeterKeys.serialNumber,
    label: 'Серийный номер',
  },
  [individualMeterKeys.model]: {
    name: individualMeterKeys.model,
    label: 'Модель',
  },
  [individualMeterKeys.mark]: {
    name: individualMeterKeys.mark,
    label: 'Марка',
  },
  [individualMeterKeys.sealNumber]: {
    name: individualMeterKeys.sealNumber,
    label: 'Номер пломбы',
  },
  [individualMeterKeys.location]: {
    name: individualMeterKeys.location,
    label: 'ID Места установки',
  },
  [individualMeterKeys.readDateTime]: {
    name: individualMeterKeys.readDateTime,
    label: 'Дата показаний',
    toExcel: toDateStr,
  },
  [individualMeterKeys.reading1]: {
    name: individualMeterKeys.reading1,
    label: 'Показания Т1',
  },
  [individualMeterKeys.reading2]: {
    name: individualMeterKeys.reading2,
    label: 'Показания Т2',
    optional: true,
  },
  [individualMeterKeys.reading3]: {
    name: individualMeterKeys.reading3,
    label: 'Показания Т3',
    optional: true,
  },
  [individualMeterKeys.installationDateTime]: {
    name: individualMeterKeys.installationDateTime,
    label: 'Дата установки',
    toExcel: toDateStr,
  },
  [individualMeterKeys.commissioningDateTime]: {
    name: individualMeterKeys.commissioningDateTime,
    label: 'Дата ввода в эксплуатацию',
    toExcel: toDateStr,
  },
  [individualMeterKeys.verificationDateTime]: {
    name: individualMeterKeys.verificationDateTime,
    label: 'Дата поверки',
    toExcel: toDateStr,
  },
  [individualMeterKeys.verificationInterval]: {
    name: individualMeterKeys.verificationInterval,
    label: 'Интервал поверки (мес)',
  },
  [individualMeterKeys.status]: {
    name: individualMeterKeys.status,
    label: 'Статус счетчика',
  },
};

export const settingStepFields = {
  [importTypes.owners]: ownersFields,
  [importTypes.personalAccounts]: personalAccountsFields,
  [importTypes.personalAccountsByCompanies]: companyPersonalAccountsFields,
  [importTypes.individualMeters]: individualMetersFields,
};
